// Poções não são vendidas: cada uso pela barra de ações (ou pelo Auto Helper) cobra do banco o preço da loja.
/** Preço de cada poção (Tibia Global): cobrado do banco a cada uso pela barra de ações / Auto Helper. [nome, preço, level] */
export const POTION_PRICES: Array<[string, number, number?]> = [
  ['small health potion', 20], ['health potion', 50], ['mana potion', 56],
  ['strong health potion', 115, 50], ['strong mana potion', 93, 50],
  ['great health potion', 225, 80], ['great mana potion', 144, 80], ['great spirit potion', 254, 80],
  ['ultimate health potion', 379, 130], ['ultimate mana potion', 438, 130], ['ultimate spirit potion', 438, 130],
  ['supreme health potion', 625, 200], ['antidote potion', 50],
  ['berserk potion', 25000], ['mastermind potion', 25000], ['bullseye potion', 25000],   // 25 mil cada (decisão do Arthur, 14/10)
];
